import Flickity from 'flickity'
import { $, each } from '../util'

const RelatedCoursesSlider = (() => {
  const init = () => {
    const container = $('.js-related-courses-slider-container')

    each(container, (i, ct) => {
      const relatedCoursesSlider = ct.querySelector('.js-related-courses-slider')

      const relatedCoursesInstance = new Flickity(relatedCoursesSlider, {
        cellSelector: '.js-related-courses-slide',
        cellAlign: 'left',
        pageDots: false,
        freeScroll: false,
        prevNextButtons: false,
        wrapAround: true,
        draggable: true,
      })
    })
  }

  return {
    init,
  }
})()

export default RelatedCoursesSlider



// WEBPACK FOOTER //
// app/javascript/scripts/components/RelatedCoursesSlider.js